import i18n from 'i18next';
import { TablePagination, CardActions } from '@mui/material';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { PAGINATION_ROWS_PER_PAGE_OPTIONS } from 'src/shared/constants/pagination';

const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  },
  pagination: {
    '& .MuiTablePagination-actions': {
      '& .MuiButtonBase-root:not(.Mui-disabled)': {
        color: theme.palette.primary.main
      }
    }
  }
}));

export const labelOfDisplayedRows = (from, to, count) =>
  `${from}-${to} ${i18n.t('of', { ns: ['common'] })} ${
    count !== -1 ? count : `${i18n.t('more than', { ns: ['common'] })} ${to}`
  }`;

const Pagination = ({ page, rowsPerPage, handleChangeRowsPerPage, onChangePage, countAllRows, ...rest }) => {
  const classes = useStyles();
  const { t } = useTranslation(['common']);

  return (
    <CardActions className={classes.actions}>
      <TablePagination
        className={classes.pagination}
        component="div"
        count={countAllRows}
        onPageChange={onChangePage}
        labelRowsPerPage={t('lines per page')}
        onRowsPerPageChange={handleChangeRowsPerPage}
        page={page}
        rowsPerPageOptions={PAGINATION_ROWS_PER_PAGE_OPTIONS}
        rowsPerPage={rowsPerPage}
        labelDisplayedRows={({ from, to, count }) => labelOfDisplayedRows(from, to, count)}
        {...rest}
      />
    </CardActions>
  );
};

Pagination.propTypes = {
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  handleChangeRowsPerPage: PropTypes.func,
  onChangePage: PropTypes.func,
  countAllRows: PropTypes.number
};

export default Pagination;
